import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guard/auth.guard';
import { MemberAccessGuard } from './shared/guard/member-access.guard';

export const routes: Routes = [
  {
    path: '',
    // AuthGuard 只負責完成 LIFF / LINE / Firebase 登入驗證，
    // 不處理 orders domain 內部的身份導流邏輯。
    canActivate: [AuthGuard],
    children: [
      {
        path: 'member',
        canActivate: [MemberAccessGuard],
        loadComponent: () => import('./features/member/member.component').then((m) => m.MemberComponent),
      },
      {
        path: 'orders',
        loadChildren: () => import('./features/orders/orders.routes'),
      },
      { path: '**', redirectTo: 'orders' },
    ],
  },
];
